import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import subMonths from 'date-fns/sub_months';
import { subQuarters, subYears, isAfter } from 'date-fns';
import { group } from 'console';
import { getCompany,getTeamByCompany,getUserAll } from './core/cacheService'
const apiUrl='https://api-node.happily.ai/powerups'

export default {
    namespaced: true,
    state: {
      optionTo: [],
      optionToForCohort: [],
      optionType: [],
      membersall: [],
      membersByTeam: [],
      organizations: [],
      teamMaster: [],
      userMaster: {},
      houseMaster: {},
      medalMaster: {},
      activeName: 'create',
      renderComponent: true,
      duplicateData: {},
      presentLibrary:[],
      currentPerfectAttendance:[],
      createRewardLoading:true,
      tempOptionTo:[],
      valuesOptional:[],
      hashTag:[],
      talentTypeOption:[],
      countAuto:0,
      loadingPresetLibrary:false,
      optionMember:[],
      medal_Master:[],
      reviewGem:{},
      giftCardOptions:[],
      customAutomations:[]
    },
    mutations: {
      setActiveTabs(state:any, obj:any) {
        
        state.activeName = obj.activeName
        state.renderComponent = obj.renderComponent
      },
      setObjDuplicate(state:any, result:any) {
        state.duplicateData = result
      },
      setOptionTo(state:any, result:any) {
        state.optionTo = result
      },
      setOptionMember(state:any, result:any) {
        state.optionMember = result
      },
      setOptionForCohort(state:any, result:any) {
        state.optionToForCohort = result
      },
      setOptionType(state:any, result:any) {
        state.optionType = result
      },
      setMemberall(state:any, result:any) {
        state.membersall = result
      },
      setMembersByTeam(state:any, result:any) {
        state.membersByTeam = result
      },
      setOrganizations(state: any, value: any) {
        state.organizations = value
      },
      setTeamMaster(state: any, value: any) {
        state.teamMaster = value
      },
      setUserMaster(state: any, value: any) {
        state.userMaster = value
      },
      setHouseMaster(state: any, value: any) {
        state.houseMaster = value
      },
      setMedalMaster(state: any, value: any) {
        state.medalMaster = value
      },
      setMenuListOfTimePeriods(state: any, value: any) {
        state.presentLibrary = value
      },
      setCurrentPerfectAttendance(state: any, value: any) {
        state.currentPerfectAttendance = value
      },
      setCreateRewardLoading(state: any, value: any) {
        state.createRewardLoading = value
      },
      setTempOptionTo(state: any, value: any) {
        state.tempOptionTo = value
      },
      setValuesOptional(state: any, value: any) {
        state.valuesOptional = value
      },
      setHashTag(state: any, value: any) {
        state.hashTag = value
      },
      setTalentTypeOption(state: any, value: any){
        state.talentTypeOption= value
      },
      setcountAuto(state: any, value: any){
        state.countAuto= value
      },
      setloadingPresetLibrary(state: any, value: any){
        state.loadingPresetLibrary= value
      },
      setMedal_Master(state: any, value: any){
        state.medal_Master= value
      },
      setReviewGem(state: any, value: any){
        state.reviewGem= value
      },
      setGiftCardOptions(state: any, value: any){
        state.giftCardOptions= value
      },
      setCustomAutomations(state: any, value: any){
        state.customAutomations= value
      },
    },
    actions: {
      async getHashtag({commit,dispatch,state,rootState}:any){
        let recognitionValue:Array<any>=[]
        let hashTag:Array<any>=[]
        let talentTypeOption:Array<any>=[]
        let medalsMaster={}
        const optionsStatus=[
          {value:'Charisma',label:'Charisma',img:'Charisma-on@3x',url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCharisma_on%402x.png?alt=media'},
          {value:'Creativity',label:'Creativity',img:'Creativity-on@3x',url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCreativity_on%402x.png?alt=media&token=0ec4601b-d61b-462c-b753-0865cf970872'},
          {value:'Initiative',label:'Initiative',img:'Initiative-on@3x',url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FInitiative_on%402x.png?alt=media&token=86c0425f-5f8b-46e9-b590-399fb38cd770'},
          {value:'Intelligence',label:'Intelligence',img:'Intelligence-on@3x',url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FIntelligence_on%402x.png?alt=media&token=fc49d407-e1ec-4029-a3fc-150b1ff4180a'},
          {value:'Kindness',label:'Kindness',img:'Kindness-on@3x',url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FKindness_on%402x.png?alt=media&token=c30267c3-147e-4a66-8b46-3a4ee9d98572'},
          {value:'Strength',label:'Strength',img:'Strength-on@3x',url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FStrength_on%402x.png?alt=media&token=b1cf8608-990d-4291-8956-1bdcb8176813'}]
  
        const companyData = await getCompany(rootState.authen.user.company)
        for(var value in companyData.hashtag){
          recognitionValue.push({
            value: value,
            label:companyData.hashtag[value].name,
          });
          hashTag.push(companyData.hashtag[value])
          talentTypeOption.push({type:companyData.hashtag[value].name})

        }
        for(const i in companyData.medals){
          let medalImage=''
          if(companyData.medals[i].image){
            const _find=_.find(optionsStatus,{url:companyData.medals[i].image})
            medalImage=_find?_find.value:companyData.medals[i].en
          }else{
            medalImage=i//companyData.medals[i].en
          }
         
          if(!medalsMaster[medalImage]){
            medalsMaster[medalImage]=[]
          }
          medalsMaster[medalImage].push({value:companyData.medals[i].en,label:companyData.medals[i].en,medalImage:medalImage,key:i,th:companyData.medals[i].th,en:companyData.medals[i].en})
        }
        commit('setTalentTypeOption',talentTypeOption)
        commit('setValuesOptional',recognitionValue) 
        commit('setHashTag',hashTag) 
        commit('setMedal_Master',medalsMaster)
      },
      getActiveTabs({commit,dispatch,state}:any){
        commit('setActiveTabs', {activeName: state.activeName, renderComponent: state.renderComponent})
      },
      async getOptionType({commit,dispatch,state}:any, user:any){
        let optionData:Array<any> = [];
        let medal:{ [key: string]: string} = {};
        let coinOpt = {
          value: "coin",
          label: "Coin",
          children: [
            {
              value: "3_coins",
              label: "+3 coins"
            },
            {
              value: "5_coins",
              label: "+5 coins"
            },
            {
              value: "coin_amount",
              label: "Custom amount"
            }
          ]
        }
        let gemOpt = {
          value: "gem",
          label: "Gem",
          children: [
            {
              value: "1_gem",
              label: "+1 gem"
            },
            {
              value: "gem_amount",
              label: "Custom amount"
            }
          ]
        }
        const company = await getCompany(user.company)
        let medalOpt:any = {value: "medal", label: "Medal", children: []}
        _.forEach(company.medal, (value, index) => {
          medal[index] = value
          medalOpt.children.push({value: index, label: "🏅"+value})
        });

        optionData.push(coinOpt)
        // optionData.push(medalOpt)
        optionData.push(gemOpt)
        commit('setMedalMaster', medal)
        commit('setOptionType', optionData)
      },
      async getOptionLeader({commit,dispatch,state,rootState}:any, user:any){
        let userData:Array<any> = [];
        let membersByTeam:Array<any> = [];
        let users:{ [key: string]: string} = {};
        const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        const allUser = await getUserAll(user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
        for(const arrData in allUser){
          const u = allUser[arrData]
          u.key = arrData
          u.value = "user_" +allUser[arrData].email
          u.value_options_cohorts = "user_" +allUser[arrData].email
          u.label = allUser[arrData].firstname + " " + allUser[arrData].lastname
          u.toType = 'user'
          if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
          if(u.profilepic_small){
            u.pic = u.profilepic_small;
          }else if (u.profilepic_crop){
            u.pic = u.profilepic_crop;
          }else if (u.profilepic){
            u.pic = u.profilepic;
          }else {
            u.pic = "";
          }
          if(membersByTeam[u.team] === undefined){
            membersByTeam[u.team] = new Array()
          }
          users[u.email] = u
          membersByTeam[u.team].push(u)
          userData.push(u)
        }
        userData = _.sortBy(userData, [function(o:any) { return o.label; }])
        commit('setOptionMember', userData)
      },
      async getOptionTo({commit,dispatch,state,rootState}:any, user:any){
        commit("setCreateRewardLoading",true)
        let optionData:Array<any> = [];
        let teamData:Array<any> = [];
        let userData:Array<any> = [];
        let membersByTeam:Array<any> = [];
        let users:{ [key: string]: string} = {};
        let house:{ [key: string]: string} = {};
        optionData.push({value: "all_members", value_options_cohorts: "all_members", label: "All Members", toType: 'all'})
        const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        for(const key in team){
          const u = team[key]
          u.key = key
          u.value = "team_" + key
          u.value_options_cohorts = "team_" + key
          u.label = team[key].name
          u.toType = 'team'
          teamData.push(u)       
         }
        teamData = _.sortBy(teamData, [function(o:any) { return o.label; }])
        // await firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
        //   snapshot.forEach((arrData):any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
        //     u.value = "team_" + arrData.key
        //     u.value_options_cohorts = "team_" + arrData.key
        //     u.label = arrData.val().name
        //     u.toType = 'team'
        //     teamData.push(u)
            
        //   });
        //   teamData = _.sortBy(teamData, [function(o:any) { return o.label; }])
        // });
        if (!rootState.main.allUser || Object.keys(rootState.main.allUser).length === 0) {
          await dispatch('main/getuser', false, { root: true });
        }
        for(const arrData in rootState.main.allUser){
          const u = rootState.main.allUser[arrData]
          u.key = arrData
          u.value = "user_" +rootState.main.allUser[arrData].email
          u.value_options_cohorts = "user_" +rootState.main.allUser[arrData].email
          u.label = rootState.main.allUser[arrData].firstname + " " + rootState.main.allUser[arrData].lastname.charAt(0)
          u.toType = 'user'
          if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
          if(u.profilepic_small){
            u.pic = u.profilepic_small;
          }else if (u.profilepic_crop){
            u.pic = u.profilepic_crop;
          }else if (u.profilepic){
            u.pic = u.profilepic;
          }else {
            u.pic = "";
          }
          if(membersByTeam[u.team] === undefined){
            membersByTeam[u.team] = new Array()
          }
          users[u.email] = u
          membersByTeam[u.team].push(u)
          userData.push(u)
        }
        let houseData = [
          {
            key: "-LWPrZbcyHAVHIFUsWLd",
            label: "House of Corvus",
            value: "house_-LWPrZbcyHAVHIFUsWLd",
            value_options_cohorts: "house_-LWPrZbcyHAVHIFUsWLd",
            toType: 'house',
          },
          {
            key: "-LWOr-XsbZM2digYl1QL",
            label: "House of Delphinus",
            value: "house_-LWOr-XsbZM2digYl1QL",
            value_options_cohorts: "house_-LWOr-XsbZM2digYl1QL",
            toType: 'house',
          },
          {
            key: "-LWPrOElCYViBd6j6qP-",
            label: "House of Leonos",
            value: "house_-LWPrOElCYViBd6j6qP-",
            value_options_cohorts: "house_-LWPrOElCYViBd6j6qP-",
            toType: 'house',
          },
        ]
        house['-LWPrZbcyHAVHIFUsWLd'] = 'House of Corvus'
        house['-LWOr-XsbZM2digYl1QL'] = 'House of Delphinus'
        house['-LWPrOElCYViBd6j6qP-'] = 'House of Leonos'
        commit('setMemberall',userData)
        commit('setTeamMaster', team)
        commit('setUserMaster', users)
        commit('setHouseMaster', house)
        userData = _.sortBy(userData, [function(o:any) { return o.label; }])
        optionData = _.concat(optionData, houseData, teamData, userData);
        commit('setMembersByTeam', membersByTeam)
        commit('setTempOptionTo', optionData)
        commit('setOptionTo', optionData)
        commit('setOptionForCohort', optionData)
        commit("setCreateRewardLoading",false)
        // firebase.database().ref('users').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
        //   snapshot.forEach((arrData):any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
        //     u.value = "user_" +arrData.val().email
        //     u.label = arrData.val().firstname + " " + arrData.val().lastname.charAt(0)
        //     u.toType = 'user'
        //     if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
        //     if(u.profilepic_small){
        //       u.pic = u.profilepic_small;
        //     }else if (u.profilepic_crop){
        //       u.pic = u.profilepic_crop;
        //     }else if (u.profilepic){
        //       u.pic = u.profilepic;
        //     }else {
        //       u.pic = "";
        //     }
        //     if(membersByTeam[u.team] === undefined){
        //       membersByTeam[u.team] = new Array()
        //     }
        //     users[u.email] = u
        //     membersByTeam[u.team].push(u)
        //     userData.push(u)
            
        //   });
        //   let houseData = [
        //     {
        //       key: "-LWPrZbcyHAVHIFUsWLd",
        //       label: "House of Corvus",
        //       value: "house_-LWPrZbcyHAVHIFUsWLd",
        //       toType: 'house',
        //     },
        //     {
        //       key: "-LWOr-XsbZM2digYl1QL",
        //       label: "House of Delphinus",
        //       value: "house_-LWOr-XsbZM2digYl1QL",
        //       toType: 'house',
        //     },
        //     {
        //       key: "-LWPrOElCYViBd6j6qP-",
        //       label: "House of Leonos",
        //       value: "house_-LWPrOElCYViBd6j6qP-",
        //       toType: 'house',
        //     },
        //   ]
        //   house['-LWPrZbcyHAVHIFUsWLd'] = 'House of Corvus'
        //   house['-LWOr-XsbZM2digYl1QL'] = 'House of Delphinus'
        //   house['-LWPrOElCYViBd6j6qP-'] = 'House of Leonos'
        //   commit('setMemberall',userData)
        //   commit('setTeamMaster', team)
        //   commit('setUserMaster', users)
        //   commit('setHouseMaster', house)
        //   userData = _.sortBy(userData, [function(o:any) { return o.label; }])
        //   optionData = _.concat(optionData, houseData, teamData, userData);
        //   commit('setMembersByTeam', membersByTeam)
        //   commit('setTempOptionTo', optionData)
        //   commit('setOptionTo', optionData)
        //   commit('setOptionForCohort', optionData)
        //   commit("setCreateRewardLoading",false)
          
        // });
      },
      getOrganization({ commit,state, rootState }: any) {
        if(state.organizations.length == 0){
          firebase.firestore().collection('organization').where("company", "==", rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            const organizations: Array<any> = [];
            querySnapshot.forEach((doc) => {
              const organization = doc.data()
              organization.key = doc.id
              organizations[organization.team_id] = organization
            });
            commit('setOrganizations', organizations)
          });
        }
      },
      async sendPowerups({commit,state,rootState,dispatch}:any,data:any){
        let value:any=data
        // console.log(value) 
        let objData:any = {}
        let to:Array<any> = [];
        let hashTag:Array<any>= [];
        let hashTags:Array<any>= [];
        let dateNow = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
        let when = (value.when == "" || !value.when) ? format(new Date(), 'YYYY-MM-DD HH:mm') :  format(value.when, 'YYYY-MM-DD HH:mm');
      
        value.value.map(data=>{
          
          let valuesOptional:any = _.find(state.valuesOptional, { value:data  });
          if(valuesOptional!==undefined){
            hashTag.push(valuesOptional.label)
          }
          let _hashTags:any = _.filter(state.hashTag, { name:valuesOptional.label });
          if(_hashTags.length > 0){
            hashTags.push(_hashTags[0])
          }
        })
        _.forEach(value.to, (value, index) => {
          if(value[0] == 'all_members'){
            to.push({name: 'All Members', type: 'all'})
          }else if(value[0].indexOf("team_") !== -1){
            let teamId = value[0].replace(/team_/g, "");
            let name = state.teamMaster[teamId].name
            to.push({name: name, type: 'team', id: teamId})
          }else if(value[0].indexOf("user_") !== -1){
            let userId = value[0].replace(/user_/g, "");
            let name = state.userMaster[userId].firstname + " " + state.userMaster[userId].lastname.charAt(0)
            to.push({name: name, type: 'user', email: userId})
          }else if(value[0].indexOf("house_") !== -1){
            let houseId = value[0].replace(/house_/g, "");
            let name = state.houseMaster[houseId]
            to.push({name: name, type: 'house', id: houseId})
          }else if(value.indexOf("user_") !== -1){
            let userId = value.replace(/user_/g, "");
            let name = state.userMaster[userId].firstname + " " + state.userMaster[userId].lastname.charAt(0)
            to.push({name: name, type: 'user', email: userId})
          }
        });
        if(value.type[0] == 'medal'){
          objData = {
            amount: parseInt(value.amount),
            company: rootState.authen.user.company,
            createdate: dateNow,
            for: value.for,
            share: value.share,
            status: false,
            total: value.recipientsUser.length,
            type: value.type[0],
            medal: value.idmedal?value.idmedal:"",
            when,
            to,
            hashtag:hashTag,
            hashtags:hashTags,
            create_user: rootState.authen.user.email,
            medals:{
              en: value.labelMedal,
              th: value.th,
              image: value.urlImage
            }

          }
          if(value.newLabel==true){
            const newId = firebase.database().ref().child(`/company/${rootState.authen.user.company}/medals`).push().key;
            objData.medal=newId
            const data = {
              en: value.labelMedal,
              th: value.labelMedal,
              image: value.urlImage
            }
            await firebase.database().ref(`/company/${rootState.authen.user.company}/medals/${newId}`).update(data)
          }
          const docRef = await firebase.firestore().collection('powerups').add(objData);

          // Broadcast to Slack (fire and forget)
          dispatch('broadcastRecognitionToSlack', {
            id: docRef.id,
            objData,
            value,
            rootState
          }, { root: false });
        }else if(value.type[0] == 'reward'){
          objData = {
            reward: value.selectedReward,
            company: rootState.authen.user.company,
            status: 'N',
            qty: 1,
            note: "",
            updated: format(when, 'YYYY-MM-DD HH:mm:ss'),
            when,
          };
          if(value.rewardDetails){
            if(value.rewardDetails.costType == 'coins'){
              objData.type = 'coin';
              objData.coin = value.rewardDetails.costValue;
            }else if(value.rewardDetails.costType == 'gems'){
              objData.type = 'gem';
              objData.gem = value.rewardDetails.costValue;
            }
          }
          objData.email_custom = {
            from: value.emailFrom || '',
            subject: value.emailSubject || '',
            message: value.for || '',
            create_user: rootState.authen.user.email,
            createdate: dateNow
          }
          if(value.recipientsUser && value.recipientsUser.length > 0){
            value.recipientsUser.map(user => {
              objData.user = user.email;
              firebase.database().ref('redeem_rewards_schedule').push(objData);
            });
          }
        }else{
          objData = {
            amount: parseInt(value.amount),
            company: rootState.authen.user.company,
            createdate: dateNow,
            for: value.for,
            share: value.share,
            status: false,
            total: value.recipientsUser.length,
            type: value.type[0],
            when,
            hashtag:hashTag,
            hashtags:hashTags,
            to,
            create_user: rootState.authen.user.email
          }
          const docRef = await firebase.firestore().collection('powerups').add(objData);

          // Broadcast to Slack (fire and forget)
          dispatch('broadcastRecognitionToSlack', {
            id: docRef.id,
            objData,
            value,
            rootState
          }, { root: false });
        }
        dispatch('getHashtag')
      },

      // Broadcast recognition to Slack (helper action)
      async broadcastRecognitionToSlack({ dispatch, rootState }: any, payload: any) {
        try {
          const id = payload.id;
          const objData = payload.objData;

          // Get user info for from/to
          const fromUserEmail = objData.create_user;
          const emailKey = fromUserEmail.replace(/\./g, '||');
          const allUser = rootState.main && rootState.main.allUser ? rootState.main.allUser : {};
          const fromUser = allUser[emailKey] || { firstname: 'Someone', lastname: '' };

          // Build recognition recipients
          const recipients = objData.to || [];
          const toUserName = recipients.length > 0 ? recipients[0].name : 'the team';
          const toUserEmail = recipients.length > 0 && recipients[0].type === 'user' ? recipients[0].email : '';

          // Build from user name
          const firstName = fromUser.firstname || '';
          const lastName = fromUser.lastname || '';
          const fullName = (firstName + ' ' + lastName).trim();
          const fromUserName = fullName || fromUserEmail;

          // Dispatch to Slack store
          dispatch('slack/broadcastRecognition', {
            id: id,
            fromUser: {
              name: fromUserName,
              email: fromUserEmail
            },
            toUser: {
              name: toUserName,
              email: toUserEmail
            },
            message: objData.for || '',
            coins: objData.amount || 0,
            values: objData.hashtag || []
          }, { root: true });
        } catch (error) {
          // Silent fail - don't block recognition flow for Slack errors
          console.warn('Failed to broadcast recognition to Slack:', error);
        }
      },

      getMenuListOfTimePeriods({commit,state,rootState,dispatch}:any){
        commit('setloadingPresetLibrary',true) 
        let schedule={}
        let count=0
        firebase.firestore().collection('powerups_schedule').where("company", "==", rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            const customAutos:Array<any> = [];
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              data.id=doc.id
              //console.log('data',data.typeLibary)
              
              // Collect custom automations separately
              if(data.typeLibary === 'custom') {
                customAutos.push(data);
                if(data.status === true){
                  count++;
                }
                return; // Skip preset library processing for custom automations
              }
              
              if(!schedule[data.typeLibary]){
                schedule[data.typeLibary]={
                  month:"",
                  quarter:"",
                  year:"",
                  day:""
                }
              }
              if(data.sendType=="month"){
                if(schedule[data.typeLibary].month==""){
                  schedule[data.typeLibary].month=data
                }else{
                 
                  if(isAfter(schedule[data.typeLibary].month.createdate, data.createdate)){
                    schedule[data.typeLibary].month=data
                  }
                }
               
              }else if(data.sendType=="quarter"){
                schedule[data.typeLibary].quarter=data
              }
              else if(data.sendType=="year"){
                schedule[data.typeLibary]['year']=data
              }else if(data.sendType=="day"){
                
                schedule[data.typeLibary]['day']=data
              }
              if(data.status==true){
                count++
              }

            })
            //console.log('schedule',schedule)
        commit('setCustomAutomations', customAutos)
        commit('setcountAuto',count)
        var presentLibrary:Array<any> = [];
        let date= format(new Date(), 'MMMM YYYY')
        let month= format(new Date(), 'MMMM YYYY')
        let month_1  = format(subMonths(date, 1), 'MMMM YYYY')
        let month_2  = format(subMonths(date, 2), 'MMMM YYYY')
        let Q= format(date, 'Q YYYY')
        let Q1= format(subQuarters(date, 1), 'Q YYYY')
        let Q2= format(subQuarters(date, 2), 'Q YYYY')
        let Y= format(date, 'YYYY')
        let Y1= format(subYears(date, 1), 'YYYY')
        let Y2= format(subYears(date, 2), 'YYYY')
        presentLibrary=[
          {
            image: "Perfect-Attendance",
            label: "Perfect Attendance",
            path:'perfectattendance',
            autoMonth:schedule['perfectattendance']?schedule['perfectattendance']['month']:"",
            autoQuarter:schedule['perfectattendance']?schedule['perfectattendance']['quarter']:"",
            autoYear:schedule['perfectattendance']?schedule['perfectattendance']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
                status:true
              },
              {
                label: Y2,
                status:true
              },
            ],
          },
          {
            image: "Super-Feedback",
            label: "Super Feedback",
            path:'superfeedback',
            autoMonth:schedule['superfeedback']?schedule['superfeedback']['month']:"",
            autoQuarter:schedule['superfeedback']?schedule['superfeedback']['quarter']:"",
            autoYear:schedule['superfeedback']?schedule['superfeedback']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
                status:true
              },
              {
                label: Y2,
                status:true
              },
            ],
          },
          {
            image: "Leading-a-Class",
            label: "Leading a Class",
            path:'leadingclass',
            autoMonth:schedule['leadingclass']?schedule['leadingclass']['month']:"",
            autoQuarter:schedule['leadingclass']?schedule['leadingclass']['quarter']:"",
            autoYear:schedule['leadingclass']?schedule['leadingclass']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
              },
            ],
          },
          {
            image: "Super-Recognition",
            label: "Super Recognition",
            path:'superrecognition',
            autoMonth:schedule['superrecognition']?schedule['superrecognition']['month']:"",
            autoQuarter:schedule['superrecognition']?schedule['superrecognition']['quarter']:"",
            autoYear:schedule['superrecognition']?schedule['superrecognition']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
                status:true
              },
              {
                label: Y2,
                status:true
              },
            ],
          },
          {
            image: "House-MVPs",
            label: "House MVPs",
            path:'housesmvp',
            autoMonth:schedule['housesmvp']?schedule['housesmvp']['month']:"",
            autoQuarter:schedule['housesmvp']?schedule['housesmvp']['quarter']:"",
            autoYear:schedule['housesmvp']?schedule['housesmvp']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
              },
            ],
          },
          {
            image: "Network-Building",
            label: "Network Building",
            path:'networkbuliding',
            autoMonth:schedule['networkbuliding']?schedule['networkbuliding']['month']:"",
            autoQuarter:schedule['networkbuliding']?schedule['networkbuliding']['quarter']:"",
            autoYear:schedule['networkbuliding']?schedule['networkbuliding']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
              },
            ],
          },
          {
            image: "New-Members",
            label: "New Members",
            path:'newmember',
            autoMonth:schedule['newmember']?schedule['newmember']['month']:"",
            autoQuarter:schedule['newmember']?schedule['newmember']['quarter']:"",
            autoYear:schedule['newmember']?schedule['newmember']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
              },
            ],
          },
          {
            image: "Active-Managers",
            label: "Active Managers",
            path:'activemanagers',
            autoMonth:schedule['activemanagers']?schedule['activemanagers']['month']:"",
            autoQuarter:schedule['activemanagers']?schedule['activemanagers']['quarter']:"",
            autoYear:schedule['activemanagers']?schedule['activemanagers']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
              },
            ],
          },
          {
            image: "Leading-Discussions",
            label: "Leading Discussions",
            path:'leadingdiscussions',
            autoMonth:schedule['leadingdiscussions']?schedule['leadingdiscussions']['month']:"",
            autoQuarter:schedule['leadingdiscussions']?schedule['leadingdiscussions']['quarter']:"",
            autoYear:schedule['leadingdiscussions']?schedule['leadingdiscussions']['year']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
                
              },
            ],
          },
          //Birthday
          {
            image: "Birthday",
            label: "Birthday",
            label_2:"Celebrations",
            path:'birthday',
            // autoMonth:schedule['birthday']?schedule['birthday']['month']:"",
            // autoQuarter:schedule['birthday']?schedule['birthday']['quarter']:"",
            // autoYear:schedule['birthday']?schedule['birthday']['year']:"",
            autoDay:schedule['birthday']?schedule['birthday']['day']:"",
            month: [
              {
                label: month,
              },
              {
                label: month_1,
              },
              {
                label: month_2,
              },
            ],
            quarter: [
              {
                label: "Q"+Q,
              },
              {
                label: "Q"+Q1,
              },
              {
                label: "Q"+Q2,
              },
            ],
            year: [
              {
                label: Y,
              },
              {
                label: Y1,
              },
              {
                label: Y2,
                
              },
            ],
            day:[{
              label: format(new Date(),"DD MMMM YYYY"),
            },]
          },
          //
          {
            image: "Work-Anniversary",
            label: "Work Anniversary",
            label_2:"Milestones",
            path:'workanniversary',
            // autoMonth:schedule['workanniversary']?schedule['workanniversary']['month']:"",
            // autoQuarter:schedule['workanniversary']?schedule['workanniversary']['quarter']:"",
            // autoYear:schedule['workanniversary']?schedule['workanniversary']['year']:"",
            autoDay:schedule['workanniversary']?schedule['workanniversary']['day']:"",
            // month: [
            //   {
            //     label: month,
            //   },
            //   {
            //     label: month_1,
            //   },
            //   {
            //     label: month_2,
            //   },
            // ],
            // quarter: [
            //   {
            //     label: "Q"+Q,
            //   },
            //   {
            //     label: "Q"+Q1,
            //   },
            //   {
            //     label: "Q"+Q2,
            //   },
            // ],
            // year: [
            //   {
            //     label: Y,
            //   },
            //   {
            //     label: Y1,
            //   },
            //   {
            //     label: Y2,
                
            //   },
            // ],
            day:[{
              label: format(new Date(),"DD MMMM YYYY"),
            },]
          },

        ]
        // console.log("presentLibrary",presentLibrary)
        commit('setMenuListOfTimePeriods',presentLibrary)
        commit('setloadingPresetLibrary',false) 
      })
      },
      getDataTo({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var axios = require('axios');
        var url=""
        var optionData:Array<any> = [];
        let currentDate= format(new Date(), 'YYYY')
        
        var config = {
          method: 'GET',
          url: apiUrl+`/`+value.data.path,
          headers: {
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Credentials': 'true',
            // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
            // 'Access-Control-Allow-Methods' : 'GET, POST, OPTIONS',
            'Content-Type': 'application/json'
          },
          params: { company:rootState.authen.user.company,typeDate:value.data.typeList ,menuList:value.data.menuList}
        };
        
        axios(config)
        .then(function (response) {
          const data = response.data
            optionData = _.sortBy(data.users, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
        })
        .catch(function (error) {
          console.log(error);
        });

      },
      saveAuto({commit,state,rootState,dispatch}:any,data:any){
        let value:any=data.form
        // console.log('data.auto',data.auto)
        let objData :any= {}
        let id=data.auto?data.auto.id:""
        let hashTag:Array<any>= [];
        let hashTags:Array<any>= [];
        let status=data.status?data.status:false
        let time=data.time
        value.value.map(data=>{
          let valuesOptional:any = _.find(state.valuesOptional, { value:data  });
          if(valuesOptional!==undefined){
            hashTag.push(valuesOptional.label)
          }
          let _hashTags:any = _.filter(state.hashTag, { name:valuesOptional.label });
          if(_hashTags.length > 0){
            hashTags.push(_hashTags[0])
          }
        })

        if(value.type[0] == 'medal'){
          objData = {
            amount: parseInt(value.amount),
            company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            for: value.for,
            share: value.share,
            status: status,
            type: value.type[0],
            medal: value.type[1],
            time:time,
            typeLibary:value.path,
            sendType:value.sendType,
            hashtag:hashTag,
            hashtags:hashTags,
            create_user: rootState.authen.user.email
          }

        }else{
          objData = {
            amount: parseInt(value.amount),
            company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            for: value.for,
            share: value.share,
            status: status,
            type: value.type[0],
            time:time,
            typeLibary:value.path,
            sendType:value.sendType,
            hashtag:hashTag,
            hashtags:hashTags,
            create_user: rootState.authen.user.email
          }
        }
        // console.log('objData',objData)
        // console.log('id',id)
        if(id){
          if(data.new_status){
            firebase.firestore().collection(`powerups_schedule`).doc(id).set({
              ...objData,
              updated_at: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }).then(()=>{
              dispatch('getMenuListOfTimePeriods')
              /*save logs*/
              dispatch(
                "authen/addLogs",
                {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
                  table: "powerups_schedule",
                  status: "create",
                  user: rootState.authen.user.email,
                },
                { root: true }
                );
              
            });
          }else{
            delete objData.createdate
            firebase.firestore().collection(`powerups_schedule`).doc(id).update({
              ...objData,
              updated_at: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }).then(()=>{
              dispatch('getMenuListOfTimePeriods')
              /*save logs*/
              dispatch(
                "authen/addLogs",
                {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
                  table: "powerups_schedule",
                  status: "update",
                  user: rootState.authen.user.email,
                },
                { root: true }
                );
              
            });
          }
          firebase.firestore().collection(`powerups_schedule`).doc(id).update({
            ...objData,
            updated_at: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
          }).then(()=>{
            dispatch('getMenuListOfTimePeriods')
            /*save logs*/
            dispatch(
              "authen/addLogs",
              {
                company: rootState.authen.user.company,
                createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
                table: "powerups_schedule",
                status: "update",
                user: rootState.authen.user.email,
              },
              { root: true }
              );
            
          });
        //  firebase.firestore().collection(`powerups_schedule`).doc(id).update(objData).then(()=>{
        //    dispatch('getMenuListOfTimePeriods')
        //  })
        }else{
          firebase.firestore().collection("powerups_schedule").add(objData).then(()=>{
            dispatch('getMenuListOfTimePeriods')
            dispatch(
              "authen/addLogs",
              {
                company: rootState.authen.user.company,
                createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
                table: "powerups_schedule",
                status: "add",
                user: rootState.authen.user.email,
              },
              { root: true }
              );
          })
        }
        

      },
      
      // Custom Automation Actions
      async saveCustomAutomation({commit, state, rootState, dispatch}:any, data:any) {
        const objData:any = {
          amount: data.form.amount,
          company: rootState.authen.user.company,
          for: data.form.message || `for ${data.form.name.toLowerCase()} in [[time_period]]`,
          share: true,
          status: data.status,
          type: data.form.type,
          time: '09:00',
          sendType: data.form.sendType,
          typeLibary: 'custom',
          hashtag: [],
          hashtags: [],
          create_user: rootState.authen.user.email,
          customRule: {
            name: data.form.name,
            targetType: data.form.targetType,
            conditions: data.form.conditions
          }
        };
        
        if (data.id) {
          await firebase.firestore().collection('powerups_schedule').doc(data.id).update({
            ...objData,
            updated_at: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
          });
          dispatch(
            "authen/addLogs",
            {
              company: rootState.authen.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "powerups_schedule",
              status: "update_custom_automation",
              user: rootState.authen.user.email,
            },
            { root: true }
          );
        } else {
          await firebase.firestore().collection('powerups_schedule').add({
            ...objData,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
          });
          dispatch(
            "authen/addLogs",
            {
              company: rootState.authen.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "powerups_schedule",
              status: "add_custom_automation",
              user: rootState.authen.user.email,
            },
            { root: true }
          );
        }
        
        dispatch('getMenuListOfTimePeriods');
      },
      
      async deleteCustomAutomation({commit, state, rootState, dispatch}:any, ruleId:string) {
        await firebase.firestore().collection('powerups_schedule').doc(ruleId).delete();
        dispatch(
          "authen/addLogs",
          {
            company: rootState.authen.user.company,
            createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
            table: "powerups_schedule",
            status: "delete_custom_automation",
            user: rootState.authen.user.email,
          },
          { root: true }
        );
        dispatch('getMenuListOfTimePeriods');
      },

      async getPerfectAttendance({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var _opData:Array<any> = [];
        var date:Array<any> = [];
        
        if(value.data.typeList=="month"){
          let date= format(value.data.menuList, 'YYYY-MM')
          let currentDate= format(new Date(), 'YYYY-MM')
          if(currentDate==date)
          {
            await dispatch('getCurrentPerfectAttendance',value)
            
            
          }else{
            firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear','==',`${date}`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  if(data.daily==100){
                    let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.email
                    });
                    if(listData[0]){
                      optionData.push(listData[0])
                      
                    }
                    
                  }
                
              })
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
       
              commit('setOptionTo', optionData)
              setTimeout(() => {
                commit("setCreateRewardLoading",false)
              }, 1000);
              
          })

          }

        }else if(value.data.typeList=="quarter"){
          let currentStatus =false
          const myArr = value.data.menuList.split(" ");
          let currentDate= format(new Date(), 'MM')
          let _date=Math.ceil(parseInt(currentDate)/3)//parseInt(currentDate)%3==0?parseInt(currentDate)/3:(parseInt(currentDate)/3)+1
          let q="Q"+(_date.toString())

          if(myArr[0]=="Q1"){
            date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          
          if(q==myArr[0]){
                currentStatus=true
                await dispatch('getCurrentPerfectAttendance',value)
          }
          //let date= format(value.data.menuList, 'YYYY-MM')
          firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where("monthyear", "in",date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                if(data.daily==100){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
              
            })
            var _optionData:Array<any> = [];
            if(q==myArr[0]){
               _optionData = _.concat(optionData, state.currentPerfectAttendance);
            }else {
              _optionData=optionData
            }
            let groupBy=_.groupBy(_optionData, 'email')
            for(let index in groupBy){
              if(!currentStatus){
                if(groupBy[index].length>=3){
                  //console.log(groupBy[index])
                  _opData.push(groupBy[index][0])
                // _optionData =_.unionBy(_optionData, 'email');
                }
              }else{
                if(parseInt(currentDate)%3==0){
                  if(groupBy[index].length>=3){
                    //console.log(groupBy[index])
                    _opData.push(groupBy[index][0])
                  // _optionData =_.unionBy(_optionData, 'email');
                  }
                }else{
                  if(groupBy[index].length>=parseInt(currentDate)%3){
                    _opData.push(groupBy[index][0])
                  }
                }
                

              }
            }
            _opData = _.sortBy(_opData, [function(o:any) { return o.label; }])
                commit('setOptionTo', _opData)
                commit("setCreateRewardLoading",false)
           
        })

        }
        else if(value.data.typeList=="year"){
          let currentStatus =false
          const myArr = value.data.menuList
          let currentDate= format(new Date(), 'YYYY')
          let currentMonth= format(new Date(), 'MM')
          date=[
            `${myArr}-01`,`${myArr}-02`,`${myArr}-03`,
            `${myArr}-04`,`${myArr}-05`,`${myArr}-06`,
            `${myArr}-07`,`${myArr}-08`,`${myArr}-09`,
            `${myArr}-10`]
          
            let date1=[
              `${myArr}-11`,`${myArr}-12`]
          if(myArr==currentDate){
            currentStatus =true
            await dispatch('getCurrentPerfectAttendance',value)
          }
          // let date= format(value.data.menuList, 'YYYY-MM')
          firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear',"in",date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                if(data.daily==100){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
              
            })
            firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear',"in",date1).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                const data=doc.data()
                if(data.daily==100){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }

              })
              var _optionData = _.concat(optionData, state.currentPerfectAttendance);
              let groupBy=_.groupBy(_optionData, 'email')
            for(let index in groupBy){

                if(!currentStatus){
                if(groupBy[index].length>=12){
                _opData.push(groupBy[index][0])
              }
              }else{
                if(parseInt(currentMonth)%12==0){
                  if(groupBy[index].length>=12){
                    _opData.push(groupBy[index][0])
              }
                }else{
                  if(groupBy[index].length>=parseInt(currentMonth)%12){
                    _opData.push(groupBy[index][0])
                  }
                }
                

              }

              
              



            }
              //_optionData =_.unionBy(_optionData, 'email');
              _opData = _.sortBy(_opData, [function(o:any) { return o.label; }])
              commit('setOptionTo', _opData)
              commit("setCreateRewardLoading",false)
            })
            
        })

        }

      },
      getCurrentPerfectAttendance({commit,state,rootState,dispatch}:any,value:any){
       
        var optionData:Array<any> = [];
        var holiday:Array<any> = [];
        var lastDayOfMonth=parseInt(format(new Date(), "D"));

        let currentDate= format(new Date(), 'YYYY-MM')
        var _data={}
        firebase.firestore().collection('holliday').where('companyid','==',value.user.company).get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              holiday.push(data)
          })
        })

        firebase.firestore().collection('users_questions').where('company','==',value.user.company).where('date',">=",`${currentDate}-01`).where("quest_id","==","-Kgs61AHOnpJ3rfyQr6t").where("status","==","close").get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              
              if(data.quest_id=="-Kgs61AHOnpJ3rfyQr6t"&&data.answer){
                if(!_data[data.users+"-"+data.date]){
                  _data[data.users+"-"+data.date]={}
                }
                _data[data.users+"-"+data.date]=data
              }
          })
          var dailyCheck={}
          state.membersall.map(value=>{
            if(!dailyCheck[value.email]){
              dailyCheck[value.email]=true
            }
            for(var i=1;i<=lastDayOfMonth;i++){
              const day=(i)<10?"0"+(i):(i)
              const date=currentDate+"-"+day
              let weekend = format(date, "dd");
              if(weekend!=="Su"&&weekend!=="Sa"){
                var _holiday = _.find(holiday, function(data){
                  return data != null && data.date == date;
                });
                if(!_holiday){
                  if(_data[value.email+"-"+date]&&dailyCheck[value.email]==true){
                    dailyCheck[value.email]=true
                  }else{
                    dailyCheck[value.email]=false
                  }
                }
              }
            }  
            if(dailyCheck[value.email]==true){
              optionData.push(value)
            }
            
          })
          // console.log("optionData",optionData)
          optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
          if(value.data.typeList=="month"){
           // console.log("optionData",optionData)
            commit('setOptionTo', optionData)
            commit("setCreateRewardLoading",false)
          }
          commit('setCurrentPerfectAttendance', optionData)
 
        })
      

      },
      async getNewmember({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var date:Array<any> = [];
        
        if(value.data.typeList=="month"){
          let date_month= format(value.data.menuList, 'YYYY-MM')
          state.membersall.map(value=>{
            var _date=format(value.createdatetime, 'YYYY-MM')
            if(_date==date_month){
              optionData.push(value)
            }            
          })
          
          optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
          commit('setOptionTo', optionData)
          commit("setCreateRewardLoading",false)
        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let currentDate= format(new Date(), 'MM')
          if(myArr[0]=="Q1"){
            date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          state.membersall.map(value=>{
            var _date=format(value.createdatetime, 'YYYY-MM')
            let _find=_.find(date, function(o) { return o == _date; });
              if(_find){
                optionData.push(value)
              }         
          })
          //console.log("optionData",optionData)
          optionData =_.unionBy(optionData, 'email');
          optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
          commit('setOptionTo', optionData)
          commit("setCreateRewardLoading",false)

        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          date=[
            `${myArr}-01`,`${myArr}-02`,`${myArr}-03`,
            `${myArr}-04`,`${myArr}-05`,`${myArr}-06`,
            `${myArr}-07`,`${myArr}-08`,`${myArr}-09`,
            `${myArr}-10`,`${myArr}-11`,`${myArr}-12`]
        
        state.membersall.map(value=>{
          var _date=format(value.createdatetime, 'YYYY-MM')
          let _find=_.find(date, function(o) { return o == _date;});
            if(_find){
              optionData.push(value)
            }         
        })
        //console.log("optionData",optionData)
        optionData =_.unionBy(optionData, 'email');
        optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
        commit('setOptionTo', optionData)
        commit("setCreateRewardLoading",false)
      }

      },
      async getLeadingClass({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var date:Array<any> = [];
        // let startDate= format(new Date(), 'MM')
        // let endDate= format(new Date(), 'MM')
        if(value.data.typeList=="month"){
          let date= format(value.data.menuList, 'YYYY-MM')

            firebase.firestore().collection('classrooms').where("company", "in", [rootState.authen.user.company,rootState.authen.user.company+'-huddles']).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  let _date= format(data.create_date, 'YYYY-MM')
                      
                    if(_date==date){
                      let listData = _.filter(state.membersall, (item): any => {
                        return item.email==data.create_user
                        });
                        if(listData[0]){
                          optionData.push(listData[0])
                        }
                    }
                    

              })
              //console.log("NEW optionData",optionData)
              optionData =_.unionBy(optionData, 'email');
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
          })
        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let startDate= format(new Date(), 'MM')
          let endDate= format(new Date(), 'MM')
          //let q="Q"+((Math.floor((parseInt(currentDate)/4))+1).toString())
          if(myArr[0]=="Q1"){

            date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){

            date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){

            date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){

            date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          firebase.firestore().collection('classrooms').where("company", "in", [rootState.authen.user.company,rootState.authen.user.company+'-huddles']).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                let _date= format(data.create_date, 'YYYY-MM')
                let _find=_.find(date, function(o) { return o == _date;});

                if(_find){
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.create_user
                    });
                    if(listData[0]){
                      optionData.push(listData[0])
                    }
                }
              
            })
            optionData =_.unionBy(optionData, 'email');
            optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
            commit('setOptionTo', optionData)
            commit("setCreateRewardLoading",false)
        })

        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          date=[
            `${myArr}-01`,`${myArr}-02`,`${myArr}-03`,
            `${myArr}-04`,`${myArr}-05`,`${myArr}-06`,
            `${myArr}-07`,`${myArr}-08`,`${myArr}-09`,
            `${myArr}-10`,`${myArr}-11`,`${myArr}-12`]
        

          firebase.firestore().collection('classrooms').where("company", "in", [rootState.authen.user.company,rootState.authen.user.company+'-huddles']).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                let _date= format(data.create_date, 'YYYY-MM')
                let _find=_.find(date, function(o) { return o == _date;});
                if(_find){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.create_user
                  });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
            })
              optionData =_.unionBy(optionData, 'email');
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
            
            
        })

        }

      },
      async getHousesMVPS({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var date:Array<any> = [];
        // let startDate= format(new Date(), 'MM')
        // let endDate= format(new Date(), 'MM')
        var Delphinus_huose:Array<any> = [];
        var Leonos_huose:Array<any> = [];
        var Corvus_huose:Array<any> = [];
        if(value.data.typeList=="month"){
          let date= format(value.data.menuList, 'YYYY-MM')

        firebase.firestore().collection(`houses/${value.user.company}-LWOr-XsbZM2digYl1QL/activities`).where('date','>=',`${date}-01`).where('date','<=',`${date}-31`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
              
                  if( data.memberslist){
                    data.memberslist.map(value=>{
                      let listData = _.filter(state.membersall, (item): any => {
                        return item.email==value.email
                        });
                        if(listData[0]){
                          Delphinus_huose.push(listData[0])
                        }
                    })
                  }
                  

              })
        })
          firebase.firestore().collection(`houses/${value.user.company}-LWPrOElCYViBd6j6qP-/activities`).where('date','>=',`${date}-01`).where('date','<=',`${date}-31`).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
   
                if( data.memberslist){
                  data.memberslist.map(value=>{
                    let listData = _.filter(state.membersall, (item): any => {
                      return item.email==value.email
                      });
                      if(listData[0]){
                        Leonos_huose.push(listData[0])
                      }
                  })
                }
            })

        })
        firebase.firestore().collection(`houses/${value.user.company}-LWPrZbcyHAVHIFUsWLd/activities`).where('date','>=',`${date}-01`).where('date','<=',`${date}-31`).get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              if( data.memberslist){
                data.memberslist.map(value=>{
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==value.email
                    });
                    if(listData[0]){
                      Corvus_huose.push(listData[0])
                    }
                })
              }
 
          })
          Delphinus_huose = _.orderBy(Delphinus_huose, ['xp'], [ 'desc']);
          Leonos_huose = _.orderBy(Leonos_huose, ['xp'], [ 'desc']);
          Corvus_huose = _.orderBy(Corvus_huose, ['xp'], [ 'desc']);
          optionData.push(Delphinus_huose[0],Leonos_huose[0],Corvus_huose[0])
          optionData =_.unionBy(optionData, 'email');
          optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
          commit('setOptionTo', optionData)
          commit("setCreateRewardLoading",false)
        })
        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let startDate= format(new Date(), 'YYYY-MM')
          let endDate= format(new Date(), 'YYYY-MM')
          //let q="Q"+((Math.floor((parseInt(currentDate)/4))+1).toString())
          if(myArr[0]=="Q1"){
          startDate= format(`${myArr[1]}-01`, 'YYYY-MM')
          endDate= format(`${myArr[1]}-03`, 'YYYY-MM')
          //date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            startDate= format(`${myArr[1]}-04`, 'YYYY-MM')
            endDate= format(`${myArr[1]}-06`, 'YYYY-MM')
            //date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            startDate= format(`${myArr[1]}-07`, 'YYYY-MM')
            endDate= format(`${myArr[1]}-09`, 'YYYY-MM')
            //date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            startDate= format(`${myArr[1]}-10`, 'YYYY-MM')
            endDate= format(`${myArr[1]}-12`, 'YYYY-MM')
            //date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }

          firebase.firestore().collection(`houses/${value.user.company}-LWOr-XsbZM2digYl1QL/activities`).where('date','>=',`${startDate}-01`).where('date','<=',`${endDate}-31`).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                if( data.memberslist){
                  data.memberslist.map(value=>{
                    let listData = _.filter(state.membersall, (item): any => {
                      return item.email==value.email
                      });
                      if(listData[0]){
                        Delphinus_huose.push(listData[0])
                      }
                  })
                }

            })
      })
        firebase.firestore().collection(`houses/${value.user.company}-LWPrOElCYViBd6j6qP-/activities`).where('date','>=',`${startDate}-01`).where('date','<=',`${endDate}-31`).get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              if( data.memberslist){
                data.memberslist.map(value=>{
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==value.email
                    });
                    if(listData[0]){
                      Leonos_huose.push(listData[0])
                    }
                })
              }
          })

      })
      firebase.firestore().collection(`houses/${value.user.company}-LWPrZbcyHAVHIFUsWLd/activities`).where('date','>=',`${startDate}-01`).where('date','<=',`${endDate}-31`).get().then((querySnapshot)=>{
        querySnapshot.forEach((doc) => {
            const data=doc.data()
            // console.log("data",data)
            if( data.memberslist){
              data.memberslist.map(value=>{
                let listData = _.filter(state.membersall, (item): any => {
                  return item.email==value.email
                  });
                  if(listData[0]){
                    Corvus_huose.push(listData[0])
                  }
              })
            }

        })
        Delphinus_huose = _.orderBy(Delphinus_huose, ['xp'], [ 'desc']);
        Leonos_huose = _.orderBy(Leonos_huose, ['xp'], [ 'desc']);
        Corvus_huose = _.orderBy(Corvus_huose, ['xp'], [ 'desc']);
        optionData.push(Delphinus_huose[0],Leonos_huose[0],Corvus_huose[0])
        optionData =_.unionBy(optionData, 'email');
        optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
        commit('setOptionTo', optionData)
        commit("setCreateRewardLoading",false)
      })


        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          let startDate= format(`${myArr}-01`, 'YYYY-MM')
          let endDate= format(`${myArr}-12`, 'YYYY-MM')
        
        firebase.firestore().collection(`houses/${value.user.company}-LWOr-XsbZM2digYl1QL/activities`).where('date','>=',`${startDate}-01`).where('date','<=',`${endDate}-31`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  if( data.memberslist){
                    data.memberslist.map(value=>{
                      let listData = _.filter(state.membersall, (item): any => {
                        return item.email==value.email
                        });
                        if(listData[0]){
                          Delphinus_huose.push(listData[0])
                        }
                    })
                  }
  
              })
        })
        firebase.firestore().collection(`houses/${value.user.company}-LWPrOElCYViBd6j6qP-/activities`).where('date','>=',`${startDate}-01`).where('date','<=',`${endDate}-31`).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                if( data.memberslist){
                  data.memberslist.map(value=>{
                    let listData = _.filter(state.membersall, (item): any => {
                      return item.email==value.email
                      });
                      if(listData[0]){
                        Leonos_huose.push(listData[0])
                      }
                  })
                }
            })
  
        })
        firebase.firestore().collection(`houses/${value.user.company}-LWPrZbcyHAVHIFUsWLd/activities`).where('date','>=',`${startDate}-01`).where('date','<=',`${endDate}-31`).get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              // console.log("data",data)
              if( data.memberslist){
                data.memberslist.map(value=>{
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==value.email
                    });
                    if(listData[0]){
                      Corvus_huose.push(listData[0])
                    }
                })
              }
  
          })
          Delphinus_huose = _.orderBy(Delphinus_huose, ['xp'], [ 'desc']);
          Leonos_huose = _.orderBy(Leonos_huose, ['xp'], [ 'desc']);
          Corvus_huose = _.orderBy(Corvus_huose, ['xp'], [ 'desc']);
          optionData.push(Delphinus_huose[0],Leonos_huose[0],Corvus_huose[0])
          optionData =_.unionBy(optionData, 'email');
          optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
          commit('setOptionTo', optionData)
          commit("setCreateRewardLoading",false)
        })

        }

      },
      async getSuperFeedback({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var optionDataCurrent:Array<any> = [];
        var date:Array<any> = [];
        var optionDataTo:Array<any> = [];
        var topValues:Array<any> = [];
        var _data:Array<any> = [];
        
        if(value.data.typeList=="month"){
          let date= format(value.data.menuList, 'YYYY-MM')
          let currentDate= format(new Date(), 'YYYY-MM')
          if(currentDate==date)
          {
            state.membersall.map((value)=>{
              topValues.push(value.super_feedback_count_month)
              optionData.push(value)
            })
            topValues =_.unionBy(topValues);
            let _topValues = topValues.sort((a,b) => b-a).slice(0,5)

            
 
            if(_topValues&&optionData){

              _topValues.map(index=>{
                
                if(index!=0){
                let list_Data = _.filter(optionData, (item): any => {
                  return item.super_feedback_count_month===index
                  });
                  _data.push(...list_Data)
                }
              })
            }

           _data = _.sortBy(_data, [function(o:any) { return o.label; }])
            commit('setOptionTo', _data)
            commit("setCreateRewardLoading",false)
            
          }else{
            firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear','==',`${date}`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                    let listData = _.find(state.membersall, (item): any => {
                    return item.email==data.email
                    });
                    if(listData){
                      topValues.push(data.super_feedback_count)
                      optionData.push({...listData,super_feedback_count:data.super_feedback_count})
                    }

              })
            //   let groupBy=(_.mapValues(_.groupBy(optionData, "super_feedback_count"), v => _.sortBy(v,['super_feedback_count']).reverse()))
            // console.log("groupBy",groupBy)
            //const groupedItems = _.mapValues(_.groupBy(optionData, "super_feedback_count"), v => _.orderBy(v, ['super_feedback_count'], ['desc']))
            topValues =_.unionBy(topValues);
            let _topValues = topValues.sort((a,b) => b-a).slice(0,5)
 
            if(_topValues&&optionData){
              _topValues.map(index=>{
                if(index!=0){
                let list_Data = _.filter(optionData, (item): any => {
                  return item.super_feedback_count===index
                  });
                  _data.push(...list_Data)
                }
              })
            }
        
              
            
    
              // let _option =_.orderBy(groupedItems, ['super_feedback_count'], ['desc']);
              // console.log("_option",_option)
              // var _optionData=[optionData[0],optionData[1],optionData[2],optionData[3],optionData[4]]
              _data = _.sortBy(_data, [function(o:any) { return o.label; }])
              // console.log("_data",_data)
              commit('setOptionTo', _data)
              commit("setCreateRewardLoading",false)
          })

          }

        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let currentDate= format(new Date(), 'MM')
          let _date=parseInt(currentDate)%3==0?parseInt(currentDate)/3:(parseInt(currentDate)/3)+1
          let q="Q"+(_date.toString())
          if(myArr[0]=="Q1"){
            date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          
          if(q==myArr[0]){
            state.membersall.map((value)=>{
              optionDataCurrent.push({...value,super_feedback_count:value.super_feedback_count_month})
            })
            optionDataCurrent =_.orderBy(optionDataCurrent, ['super_feedback_count_month'], ['desc']);

          }
          firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where("monthyear", "in",date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                  let listData = _.find(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  if(listData){
                    optionData.push({...listData,super_feedback_count:data.super_feedback_count})
                  }
                
              
            })
            var _optionData = _.concat(optionData, optionDataCurrent);
            var super_feedback_count=0
            state.membersall.map(value=>{
              super_feedback_count=0
              let listData = _.filter(_optionData, (item): any => {
                return item.email==value.email
                });
                listData.map(data=>{
                  let count=data.super_feedback_count?data.super_feedback_count:0
                  super_feedback_count=super_feedback_count+count
                  
                })
                topValues.push(super_feedback_count)
                optionDataTo.push({...value,super_feedback_count:super_feedback_count})
            })
            topValues =_.unionBy(topValues);
            let _topValues = topValues.sort((a,b) => b-a).slice(0,5)
 
            if(_topValues&&optionDataTo){
              _topValues.map(index=>{
                if(index!=0){
                let list_Data = _.filter(optionDataTo, (item): any => {
                  return item.super_feedback_count===index
                  });
                  _data.push(...list_Data)
                }
              })
            }
        
            //optionDataTo =_.orderBy(optionDataTo, ['super_feedback_count'], ['desc']);
            //console.log("sort",optionData)
            //optionDataTo=[optionDataTo[0],optionDataTo[1],optionDataTo[2],optionDataTo[3],optionDataTo[4]]
            _data = _.sortBy(_data, [function(o:any) { return o.label; }])
            commit('setOptionTo', _data)
            commit("setCreateRewardLoading",false)
        })

        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          let currentDate= format(new Date(), 'YYYY')
          date=[
            `${myArr}-01`,`${myArr}-02`,`${myArr}-03`,
            `${myArr}-04`,`${myArr}-05`,`${myArr}-06`,
            `${myArr}-07`,`${myArr}-08`,`${myArr}-09`,
            `${myArr}-10`]
          
            let date1=[
              `${myArr}-11`,`${myArr}-12`]
          if(myArr==currentDate){
            state.membersall.map((value)=>{
              optionDataCurrent.push({...value,super_feedback_count:value.super_feedback_count_month})
            })
            optionDataCurrent =_.orderBy(optionDataCurrent, ['super_feedback_count_month'], ['desc']);

          }
          // let date= format(value.data.menuList, 'YYYY-MM')
          firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear',"in",date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
               
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                
              
            })
            firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear',"in",date1).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                const data=doc.data()
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                

              })
              var _optionData = _.concat(optionData, optionDataCurrent);
            var super_feedback_count=0
            state.membersall.map(value=>{
              super_feedback_count=0
              let listData = _.filter(_optionData, (item): any => {
                return item.email==value.email
                });
                listData.map(data=>{
                  let count=data.super_feedback_count?data.super_feedback_count:0
                  super_feedback_count=super_feedback_count+count
                })
                optionDataTo.push({...value,super_feedback_count:super_feedback_count})
                topValues.push(super_feedback_count)
            })

            topValues =_.unionBy(topValues);
            let _topValues = topValues.sort((a,b) => b-a).slice(0,5)
            if(_topValues&&optionDataTo){
              _topValues.map(index=>{

                if(index!=0){
                let list_Data = _.filter(optionDataTo, (item): any => {
                  return item.super_feedback_count===index
                  });
                  
                  _data.push(...list_Data)
                }
              })
            }

            //optionDataTo =_.orderBy(optionDataTo, ['super_feedback_count'], ['desc']);
            //optionDataTo=[optionDataTo[0],optionDataTo[1],optionDataTo[2],optionDataTo[3],optionDataTo[4]]
            _data = _.sortBy(_data, [function(o:any) { return o.label; }])
            commit('setOptionTo', _data)
            commit("setCreateRewardLoading",false)
            })
            
        })

        }

      },
      async getSuperRecognition({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var optionDataCurrent:Array<any> = [];
        var date:Array<any> = [];
        var optionDataTo:Array<any> = [];
        
        if(value.data.typeList=="month"){
          let date= format(value.data.menuList, 'YYYY-MM')
          let currentDate= format(new Date(), 'YYYY-MM')
          if(currentDate==date)
          {
            firebase.firestore().collection('toneanalyze').where('company','==',value.user.company).where('date','>=',`${date}-01`).where('date','<=',`${date}-31`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                const data=doc.data()
                
                if(data.effort=="100"&&(data.type=="5coins"||data.type=="3coins")){
                  
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.email
                    });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
              })
              optionData =_.unionBy(optionData, 'email');
            optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
            commit('setOptionTo', optionData)
            commit("setCreateRewardLoading",false)
            
            })
        
          }else{
            firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear','==',`${date}`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  if(data.super_recognition>0){
                    let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.email
                    });
                    if(listData[0]){
                      optionData.push(listData[0])
                    }
                  }

              })
              optionData =_.unionBy(optionData, 'email');
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
          })

          }

        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let currentDate= format(new Date(), 'MM')
          let _date=parseInt(currentDate)%3==0?parseInt(currentDate)/3:(parseInt(currentDate)/3)+1
          let q="Q"+(_date.toString())
          if(myArr[0]=="Q1"){
            date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          
          if(q==myArr[0]){
            firebase.firestore().collection('toneanalyze').where('company','==',value.user.company).where('date','>=',`${date}-01`).where('date','<=',`${date}-31`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                const data=doc.data()
                
                if(data.effort=="100"&&(data.type=="5coins"||data.type=="3coins")){
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.email
                    });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
              })})
          }
          //let date= format(value.data.menuList, 'YYYY-MM')
          firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where("monthyear", "in",date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                if(data.super_recognition>0){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
                
              
            })
            var _optionData = _.concat(optionData);
            _optionData =_.unionBy(_optionData, 'email');
            _optionData = _.sortBy(_optionData, [function(o:any) { return o.label; }])
            commit('setOptionTo', _optionData)
            commit("setCreateRewardLoading",false)
        })

        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          let currentDate= format(new Date(), 'YYYY')
          date=[
            `${myArr}-01`,`${myArr}-02`,`${myArr}-03`,
            `${myArr}-04`,`${myArr}-05`,`${myArr}-06`,
            `${myArr}-07`,`${myArr}-08`,`${myArr}-09`,
            `${myArr}-10`]
          
            let date1=[
              `${myArr}-11`,`${myArr}-12`]
          if(myArr==currentDate){
            firebase.firestore().collection('toneanalyze').where('company','==',value.user.company).where('date','>=',`${date}-01`).where('date','<=',`${date}-31`).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                const data=doc.data()
                
                if(data.effort=="100"&&(data.type=="5coins"||data.type=="3coins")){
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.email
                    });
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
              })})
          }
          // let date= format(value.data.menuList, 'YYYY-MM')
          firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear',"in",date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                if(data.super_recognition>0){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }
              
            })
            firebase.firestore().collection('report_monthly').where('company','==',value.user.company).where('monthyear',"in",date1).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                const data=doc.data()
                if(data.super_recognition>0){
                  let listData = _.filter(state.membersall, (item): any => {
                  return item.email==data.email
                  });
                  
                  if(listData[0]){
                    optionData.push(listData[0])
                  }
                }

              })
              var _optionData = _.concat(optionData);
              _optionData =_.unionBy(_optionData, 'email');
              _optionData = _.sortBy(_optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', _optionData)
              commit("setCreateRewardLoading",false)
            })
            
        })

        }

      },
      async getLeadingDiscussions({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var optionDataCurrent:Array<any> = [];
        var date:Array<any> = [];
        var optionDataTo:Array<any> = [];
        
        if(value.data.typeList=="month"){
          let startdate= format(value.data.menuList, 'YYYY-MM-01')
          let Enddate= format(value.data.menuList, 'YYYY-MM-31')
          let currentDate= format(new Date(), 'YYYY-MM')

            firebase.firestore().collection('townhall').where('company','==',value.user.company).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  let _date=format(data.create_date, 'YYYY-MM-DD')
                  if(_date>=startdate&&_date<=Enddate){
                    let listData = _.filter(state.membersall, (item): any => {
                      return item.email==data.create_user
                      });
                      if(listData[0]){
                        optionData.push(listData[0])
                      }
                  }
                
              })
              optionData =_.unionBy(optionData, 'email');
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
          })

          

        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let currentDate= format(new Date(), 'MM')
          var startdate=""
          var Enddate=""
          let _date=parseInt(currentDate)%3==0?parseInt(currentDate)/3:(parseInt(currentDate)/3)+1
          let q="Q"+(_date.toString())
          if(myArr[0]=="Q1"){
            startdate= format(myArr[1], 'YYYY-01-01')
            Enddate= format(myArr[1], 'YYYY-03-31')
            //date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            startdate= format(myArr[1], 'YYYY-04-01')
            Enddate= format(myArr[1], 'YYYY-06-30')
            //date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            startdate= format(myArr[1], 'YYYY-07-01')
            Enddate= format(myArr[1], 'YYYY-09-30')
            //date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            startdate= format(myArr[1], 'YYYY-10-01')
            Enddate= format(myArr[1], 'YYYY-12-31')
            // date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          

          firebase.firestore().collection('townhall').where('company','==',value.user.company).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                let _date=format(data.create_date, 'YYYY-MM-DD')
                if(_date>=startdate&&_date<=Enddate){
                  let listData = _.filter(state.membersall, (item): any => {
                    return item.email==data.create_user
                    });
                    if(listData[0]){
                      optionData.push(listData[0])
                    }
                }
              
            })
            optionData =_.unionBy(optionData, 'email');
            optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
            commit('setOptionTo', optionData)
            commit("setCreateRewardLoading",false)
        })

        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          let currentDate= format(new Date(), 'YYYY')
          var startdate= format(myArr, 'YYYY-01-01')
          var Enddate= format(myArr, 'YYYY-12-31')
              firebase.firestore().collection('townhall').where('company','==',value.user.company).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    let _date=format(data.create_date, 'YYYY-MM-DD')
                    if(_date>=startdate&&_date<=Enddate){
                      let listData = _.filter(state.membersall, (item): any => {
                        return item.email==data.create_user
                        });
                        if(listData[0]){
                          optionData.push(listData[0])
                        }
                    }
                  
                })
                optionData =_.unionBy(optionData, 'email');
                optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
                commit('setOptionTo', optionData)
                commit("setCreateRewardLoading",false)
            })

        }

      },
      async getActiveManagers({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var optionData:Array<any> = [];
        var optionDataCurrent:Array<any> = [];
        var date:Array<any> = [];
        var optionDataTo:Array<any> = [];
        var manager={}
        var _openMail={}
        let managerRate:Array<any> = [];
        let OpenMail:Array<any> = [];
        if(value.data.typeList=="month"){
          let startdate= format(value.data.menuList, 'YYYY-MM-01')
          let Enddate= format(value.data.menuList, 'YYYY-MM-31')

          firebase.firestore().collection('insight_manager_today').where('company','==',value.user.company).where('date','>=',`${startdate}`).where('date','<=',`${Enddate}`).get().then(snapshot => {
            snapshot.forEach(childSnapshot => {
                var _data = childSnapshot.data()
                
               if(_data.type==="feedback"){
                managerRate.push(_data)
               }else if( _data.type==="report_daily_boss" || _data.type==="report_weekly_boss"){
                
                OpenMail.push(_data)
               }
            })
            var grouped_managerRate = _.groupBy(managerRate, 'email')
            var grouped_OpenMail = _.groupBy(OpenMail, 'email')
            for(const group in grouped_managerRate){

              var read=0
              var receive=0
              grouped_managerRate[group].map((value)=>{
                read=read+value.read
                receive = receive + value.receive
              })
              manager[group]=(isNaN(Math.round(read * 100 / receive)) ? 0 : Math.round(read * 100 / receive))
            }
            for(const group in grouped_OpenMail){

              var _read=0
              var _receive=0
              grouped_OpenMail[group].map((value)=>{
                _read=_read+value.read
                _receive = _receive + value.receive
              })
              _openMail[group]=(isNaN(Math.round(_read * 100 / _receive)) ? 0 : Math.round(_read * 100 / _receive))
            }
   
            state.membersall.map((data)=>{
              if(_openMail[data.email]>=50&&manager[data.email]>=30)
              {
                //console.log(data)
                optionData.push(data)
              }
            })
              
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
          })
        }else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let currentDate= format(new Date(), 'MM')
          var startdate=""
          var Enddate=""
          let _date=parseInt(currentDate)%3==0?parseInt(currentDate)/3:(parseInt(currentDate)/3)+1
          let q="Q"+(_date.toString())
          if(myArr[0]=="Q1"){
            startdate= format(myArr[1], 'YYYY-01-01')
            Enddate= format(myArr[1], 'YYYY-03-31')
            //date=[`${myArr[1]}-01`,`${myArr[1]}-02`,`${myArr[1]}-03`]
          }else if(myArr[0]=="Q2"){
            startdate= format(myArr[1], 'YYYY-04-01')
            Enddate= format(myArr[1], 'YYYY-06-30')
            //date=[`${myArr[1]}-04`,`${myArr[1]}-05`,`${myArr[1]}-06`]
          }else if(myArr[0]=="Q3"){
            startdate= format(myArr[1], 'YYYY-07-01')
            Enddate= format(myArr[1], 'YYYY-09-30')
            //date=[`${myArr[1]}-07`,`${myArr[1]}-08`,`${myArr[1]}-09`]
          }else if(myArr[0]=="Q4"){
            startdate= format(myArr[1], 'YYYY-10-01')
            Enddate= format(myArr[1], 'YYYY-12-31')
            // date=[`${myArr[1]}-10`,`${myArr[1]}-11`,`${myArr[1]}-12`]
          }
          firebase.firestore().collection('insight_manager_today').where('company','==',value.user.company).where('date','>=',`${startdate}`).where('date','<=',`${Enddate}`).get().then(snapshot => {
            snapshot.forEach(childSnapshot => {
                var _data = childSnapshot.data()
               if(_data.type==="feedback"){
                managerRate.push(_data)
               }else if( _data.type==="report_daily_boss" || _data.type==="report_weekly_boss"){
                OpenMail.push(_data)
               }
            })
            var grouped_managerRate = _.groupBy(managerRate, 'email')
            var grouped_OpenMail = _.groupBy(OpenMail, 'email')
            for(const group in grouped_managerRate){

              var read=0
              var receive=0
              grouped_managerRate[group].map((value)=>{
                read=read+value.read
                receive = receive + value.receive
              })
              manager[group]=(isNaN(Math.round(read * 100 / receive)) ? 0 : Math.round(read * 100 / receive))
            }
            for(const group in grouped_OpenMail){
              var _read=0
              var _receive=0
              grouped_OpenMail[group].map((value)=>{
                _read=_read+value.read
                _receive = _receive + value.receive
              })
              _openMail[group]=(isNaN(Math.round(_read * 100 / _receive)) ? 0 : Math.round(_read * 100 / _receive))
            }
            state.membersall.map((data)=>{
              if(_openMail[data.email]>=50&&manager[data.email]>=30)
              {
                optionData.push(data)
              }
            })
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
          })

         

        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          let currentDate= format(new Date(), 'YYYY')
          var startdate= format(myArr, 'YYYY-01-01')
          var Enddate= format(myArr, 'YYYY-12-31')
          firebase.firestore().collection('insight_manager_today').where('company','==',value.user.company).where('date','>=',`${startdate}`).where('date','<=',`${Enddate}`).get().then(snapshot => {
            snapshot.forEach(childSnapshot => {
                var _data = childSnapshot.data()
               if(_data.type==="feedback"){
                managerRate.push(_data)
               }else if( _data.type==="report_daily_boss" || _data.type==="report_weekly_boss"){
                OpenMail.push(_data)
               }
            })
            var grouped_managerRate = _.groupBy(managerRate, 'email')
            var grouped_OpenMail = _.groupBy(OpenMail, 'email')
            for(const group in grouped_managerRate){

              var read=0
              var receive=0
              grouped_managerRate[group].map((value)=>{
                read=read+value.read
                receive = receive + value.receive
              })
              manager[group]=(isNaN(Math.round(read * 100 / receive)) ? 0 : Math.round(read * 100 / receive))
            }
            for(const group in grouped_OpenMail){
 
              var _read=0
              var _receive=0
              grouped_OpenMail[group].map((value)=>{
                _read=_read+value.read
                _receive = _receive + value.receive
              })
              _openMail[group]=(isNaN(Math.round(_read * 100 / _receive)) ? 0 : Math.round(_read * 100 / _receive))
            }
            state.membersall.map((data)=>{
              if(_openMail[data.email]>=50&&manager[data.email]>=30)
              {
                optionData.push(data)
              }
            })
              optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
          })

        }

      },
      async getNetworkBuliding({commit,state,rootState,dispatch}:any,value:any){
        commit("setCreateRewardLoading",true)
        var axios = require('axios');
        var url=""
        var optionData:Array<any> = [];
        let currentDate= format(new Date(), 'YYYY')
        if(value.data.typeList=="month"){
          let date=format(value.data.menuList, 'M')
          url=`https://relationship-api-bv43tjyzrq-uc.a.run.app/api/new-connections/companies/-Kv0X8SSurYL3y1MZAWL/years/${currentDate}/months/${date}`
        }
        else if(value.data.typeList=="quarter"){
          const myArr = value.data.menuList.split(" ");
          let quarters=myArr[0].replace("Q", "");
          url=`https://relationship-api-bv43tjyzrq-uc.a.run.app/api/new-connections/companies/-Kv0X8SSurYL3y1MZAWL/years/${myArr[1]}/quarters/${quarters}`
        }
        else if(value.data.typeList=="year"){
          const myArr = value.data.menuList
          url=`https://relationship-api-bv43tjyzrq-uc.a.run.app/api/new-connections/companies/-Kv0X8SSurYL3y1MZAWL/years/${myArr}`
        }
        var config = {
          method: 'GET',
          url: url,//'https://relationship-api-bv43tjyzrq-uc.a.run.app/api/new-connections/companies/-Kv0X8SSurYL3y1MZAWL/years/2020/months/1',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization':'Bearer veTMEvyK0PrLvUQ4DipfceAnvK4Luw',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization',
            'Access-Control-Allow-Methods' : 'GET, POST, OPTIONS',
          },
          // headers: { 
          //   ...data.getHeaders()
          // },
          //data : data
        };
        
        axios(config)
        .then(function (response) {
          const data = response.data

          data.map(value=>{
            let listData = _.filter(state.membersall, (item): any => {
              return item.email==value
              });
              if(listData[0]){
                optionData.push(listData[0])
              }

          })
            optionData = _.sortBy(optionData, [function(o:any) { return o.label; }])
              commit('setOptionTo', optionData)
              commit("setCreateRewardLoading",false)
        })
        .catch(function (error) {
          console.log(error);
        });

        

      },
      getOptionToRecipient({commit,state,rootState,dispatch}:any,value:any){
        commit('setOptionTo', state.tempOptionTo)
      },
      async getGiftCardOptions({commit,state,rootState,dispatch}:any, user:any){
        let giftCardOptions:Array<any> = [];
        try {
          // Fetch company data to get tag_master
          const companyData = await getCompany(user.company);
          const tagMaster = companyData.tag_master || {};
          
          // Find gift card tag value (typically '0')
          let giftCardTagValue = '0';
          for (const key in tagMaster) {
            if (tagMaster[key].value === 'gift_cards') {
              giftCardTagValue = key;
              break;
            }
          }
          
          // Fetch rewards from Firebase Realtime Database
          await firebase.database().ref(`rewards_company/${user.company}`).once('value', snapshot => {
            if (!snapshot.exists()) {
              commit('setGiftCardOptions', []);
              return;
            }
            
            snapshot.forEach((doc): any => {
              try {
                const data = doc.val();
                
                // Validate reward data structure
                if (!data || typeof data !== 'object') {
                  return;
                }
                
                // Check if enabled - try multiple possible field names and values
                const isEnabled = data.block === 'Y' || 
                                  data.block === true || 
                                  data.block === 1 ||
                                  data.status === 'active' ||
                                  data.status === 'Y' ||
                                  data.status === true ||
                                  data.active === true ||
                                  data.active === 'Y' ||
                                  data.enabled === true ||
                                  data.enabled === 'Y';
                
                if (isEnabled) {
                  // Check if it's a gift card OR if no tag filtering (show all enabled rewards)
                  const isGiftCard = data.tag_value === giftCardTagValue;
                  
                  // Include if it's a gift card OR if we want to show all enabled rewards as fallback
                  if (isGiftCard || giftCardTagValue === '0') {
                    const costType = (data.gems && data.gems > 0) ? 'gems' : 'coins';
                    const costValue = (data.gems && data.gems > 0) ? data.gems : (data.coins || 0);
                    
                    // Get image URL - try multiple possible field names
                    let imageUrl = data.img || data.image || data.imgUrl || data.image_url || data.imageUrl || '';
                    
                    // If no direct image URL, check for filepath and construct Firebase Storage URL
                    if (!imageUrl && data.filepath && typeof data.filepath === 'string') {
                      try {
                        let path = data.filepath;
                        const fstr = 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/';
                        const lstr = '?alt=media';
                        path = path.replace(/\//g, '%2F');
                        imageUrl = fstr + path + lstr;
                      } catch (error) {
                        // Silently handle image path errors
                      }
                    }
                    
                    const option = {
                      key: doc.key,
                      value: doc.key,
                      label: data.reward_en || data.name_en || '',
                      reward_en: data.reward_en || data.name_en || '',
                      description_en: data.description_en || '',
                      coins: data.coins || 0,
                      gems: data.gems || 0,
                      costType: costType,
                      costValue: costValue,
                      img: imageUrl,
                      country: data.country || 'All Countries',
                      tag_value: data.tag_value || '',
                      reward_currency: data.reward_currency || '',
                      provider: data.provider || '',
                      price: Number(data.price) || 0
                    };
                    
                    giftCardOptions.push(option);
                  }
                }
              } catch (err) {
                console.error(`Error processing reward ${doc.key}:`, err);
              }
            });
          });
          
          // Sort by name
          giftCardOptions = _.sortBy(giftCardOptions, ['reward_en']);
          commit('setGiftCardOptions', giftCardOptions);
        } catch (error) {
          console.error('Error fetching gift cards:', error);
          commit('setGiftCardOptions', []);
        }
      },
      async getReviewGem({commit,state,rootState,dispatch}:any,id:any){
        let review_gem:any={}
        await firebase.firestore().collection(`send_review_gem`).doc(id).get().then(async (doc) => {    
          if (doc.exists) {
  
            review_gem=doc.data()
          } 
          //  console.log('review_gem',review_gem)
          commit('setReviewGem', review_gem)
        })
      },
      async updateReviewGemSendPowerups({commit,state,rootState,dispatch}:any,id:any){
        const send_powerups=state.reviewGem.email_openai
        const data={...send_powerups,send_powerups:true}
        await firebase.firestore().collection(`send_review_gem`).doc(id).update({email_openai:data})

      }
      


    },
    getters: {
      activeName : (state:any) => {
        return state.activeName
      },
      renderComponent : (state:any) => {
        return state.renderComponent
      },
      optionTo : (state:any) => {
        return state.optionTo
      },
      optionToForCohort : (state:any) => {
        return state.optionToForCohort
      },
      optionMember : (state:any) => {
        return state.optionMember
      },
      optionType : (state:any) => {
        return state.optionType
      },
      membersByTeam : (state:any) => {
        return state.membersByTeam
      },
      membersall : (state:any) => {
        return state.membersall
      },
      organizations : (state:any) => {
        return state.organizations
      },
      teamMaster : (state:any) => {
        return state.teamMaster
      },
      medalMaster : (state:any) => {
        return state.medalMaster
      },
      houseMaster : (state:any) => {
        return state.houseMaster
      },
      duplicateData : (state:any) => {
        return state.duplicateData
      },
      presentLibrary : (state:any) => {
        return state.presentLibrary
      },
      createRewardLoading: (state:any) => {
        return state.createRewardLoading
      },
      valuesOptional: (state:any) => {
        return state.valuesOptional
      },
      talentTypeOption: (state:any) => {
        return state.talentTypeOption
      },
      countAuto: (state:any) => {
        return state.countAuto
      },
      loadingPresetLibrary: (state:any) => {
        return state.loadingPresetLibrary
      },
      medal_Master: (state:any) => {
        return state.medal_Master
      },
      reviewGem: (state:any) => {
        return state.reviewGem
      },
      giftCardOptions: (state:any) => {
        return state.giftCardOptions
      },
      customAutomations: (state:any) => {
        return state.customAutomations || []
      },
    }
  }